import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  private endpoint = environment.urlAPI + '/artigo/feedback';

  constructor(private http: HttpClient) {}

  saveFeedback(id: number, thumbs: string, comentario: string) {
    return this.http.post<void>(
      this.endpoint,
      JSON.stringify({ id, thumbs, comentario }),
      {
        responseType: 'text' as 'json',
      }
    );
  }
}
